import { render, staticRenderFns } from "./ModalProductsUpdate.vue?vue&type=template&id=4f1d1fae&"
import script from "./ModalProductsUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalProductsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductsUpdate.vue?vue&type=style&index=0&id=4f1d1fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports